import React, { Component } from "react"
import { Map, TileLayer, Marker } from "react-leaflet"
import L from 'leaflet'

const MyMarker = props => {

  const initMarker = ref => {
    if (ref) {
      ref.leafletElement.openPopup()
    }
  }

  return <Marker ref={initMarker} {...props} />
}

class MapExample extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPos: {}
    };
  }

  render() {

    const myIcon = L.icon({
      iconUrl: require('../assets/images/map-marker-icon.png'),
      iconSize: [42, 64],
      iconAnchor: [21, 64],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    });
    return (
      <Map center={this.props.center} zoom={this.props.zoom} style={{ maxHeight: 400, border: 'none' }}>
        <TileLayer
          url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
        />
        {this.props.center && <MyMarker icon={myIcon} position={this.props.center}>

        </MyMarker>}
      </Map>
    )
  }
}

export default MapExample;
